import React, { useEffect, useRef, useState } from 'react';
import { Card, Loader, Search } from 'src/components';
import { DashboardLayout } from 'src/containers';

import { useNavigate, useParams } from 'react-router-dom';
import useFetch from 'src/hooks/useFetch';
import Button from 'src/components/button';
import Service from 'src/setup/network';
import Title from 'src/components/title';
import Description from 'src/components/Description';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ReactToPrint from 'react-to-print';
import { BsArrowLeft } from 'react-icons/bs';
import DateFormat from 'src/components/DateFormat';

interface IProps {}

const ViewShift: React.FC<IProps> = ({}) => {
  const navigate = useNavigate();
  const componentRef: any = useRef();
  const [singleShiftData, setSingleShiftData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  const { id } = useParams();

  const fetchSingleShiftData = async () => {
    setIsLoading(true);
    try {
      const response = await Service.get(`/shifts/details/${id}`);
      const data = await response?.data;
      setSingleShiftData(data);
      setIsLoading(false);
    } catch (err: any) {}
  };
  useEffect(() => {
    fetchSingleShiftData();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="ml-4  w-max ">
            <div className="flex items-center justify-end space-x-4">
              <Button
                text="View Cash Drawer"
                variant="primary"
                onClick={() => navigate(`/cash/${id}`)}
              />
              <ReactToPrint
                trigger={() => <Button text="Print Report" />}
                content={() => componentRef.current}
                removeAfterPrint={true}
              />
            </div>
            <div ref={componentRef} className="ml-4  w-max ">
              <div className="mt-4 text-[black]">
                <p>
                  <span className="mr-1">Opened at: </span>
                  {<DateFormat text={singleShiftData?.openedAt || ''} />}
                  <span className="font-bold text-base ml-2 capitalize">
                    {' '}
                    ( By {singleShiftData && singleShiftData?.openedBy?.name})
                  </span>
                </p>
                <p className="mt-3">
                  {' '}
                  <span className="mr-1">Closed at: </span>
                  {<DateFormat text={singleShiftData?.closedAt || ''} />}
                  {singleShiftData && singleShiftData?.closedAt && (
                    <span className="font-bold text-base ml-2 capitalize">
                      (By {singleShiftData && singleShiftData?.closedBy?.name})
                    </span>
                  )}
                </p>
              </div>
              <div className="flex space-x-20 w-max ">
                <div className="mt-4 min-w-[40%] w-[420px]  ">
                  <Title text="Cash Drawer" className="mb-4 font-bold" />
                  <Card className="text-black h-[400px]">
                    <Description
                      text="Opening Float"
                      data={
                        singleShiftData &&
                        singleShiftData?.cashDrawerInfo?.openingFloat
                      }
                    />
                    <Description
                      text="Cash Payments"
                      data={
                        singleShiftData &&
                        singleShiftData?.cashDrawerInfo?.cashPayments
                      }
                    />
                    <Description
                      text="Cash Refunds"
                      data={
                        singleShiftData &&
                        singleShiftData?.cashDrawerInfo?.cashRefunds
                      }
                    />
                    <Description
                      text="Cash In"
                      data={
                        singleShiftData &&
                        singleShiftData?.cashDrawerInfo?.cashIn
                      }
                    />
                    <Description
                      text="Cash Out"
                      data={
                        singleShiftData &&
                        singleShiftData?.cashDrawerInfo?.cashOut
                      }
                      className="border-b border-border-color pb-4"
                    />
                    <Description
                      text="Expected Cash Amount"
                      data={
                        singleShiftData &&
                        singleShiftData?.cashDrawerInfo?.expectedCash
                      }
                      className="font-bold"
                    />
                    <Description
                      text="Actual Cash Amount"
                      data={
                        singleShiftData &&
                        singleShiftData?.cashDrawerInfo?.actualCash
                      }
                      className="font-bold"
                    />
                    <Description
                      text="Difference"
                      data={
                        singleShiftData &&
                        singleShiftData?.cashDrawerInfo?.difference
                      }
                      className="font-bold"
                    />
                  </Card>
                </div>

                <div className=" min-w-[40%] w-[420px] pb-8 mt-4">
                  <Title text="Sales Summary" className="mb-4 font-bold" />
                  <Card className="text-[black] h-[400px]">
                    <Description
                      text="Gross Sales"
                      data={
                        singleShiftData &&
                        singleShiftData?.salesSummary?.grossSales
                      }
                    />
                    <Description
                      text="Refunds"
                      data={
                        singleShiftData &&
                        singleShiftData?.salesSummary?.refundsTotal
                      }
                    />
                    <Description text="Discounts" data={0} />
                    <Description
                      text="Extra Charge"
                      data={
                        singleShiftData &&
                        singleShiftData?.cashDrawerInfo?.openingFloat
                      }
                      className="border-b border-border-color pb-4"
                    />
                    <Description
                      text="Net Sales"
                      data={
                        singleShiftData &&
                        singleShiftData?.salesSummary?.netSales
                      }
                      className="font-bold"
                    />
                    <Description
                      text="Cash"
                      data={
                        singleShiftData &&
                        singleShiftData?.salesSummary?.salesByOrigin[0]?.cash
                          ?.total
                      }
                    />
                    <Description
                      text="Fonepay"
                      data={
                        singleShiftData &&
                        singleShiftData?.salesSummary?.salesByOrigin[2]?.fonepay
                          ?.total
                      }
                    />
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default React.memo(ViewShift);
